<template lang="pug">
.analysisDevice
  header
    el-select.action(v-model="params.actions" :placeholder="$t('Analysis.Event.select_action')" size="small" multiple)
      el-option(v-for="action in actions" :key="action.name" :label="$t(action.name)" :value="action.type")
    el-select.group(v-model="params.groups" :placeholder="$t('Analysis.Event.select_group')" size="small" multiple)
      el-option(v-for="group in groups" :key="group.id" :label="group.name" :value="group.id")
    el-date-picker.picker(v-model="params.daterange" type="daterange" size="small" align="right" unlink-panels
                          range-separator="〜" :start-placeholder="$t('Analysis.start_date')"
                          :end-placeholder="$t('Analysis.end_date')" :picker-options="options"
                          :value-format="'yyyy-MM-dd'")

  #graphs
    .devices-graph
      h1 {{ $t('Analysis.Device.title01') }}
      el-row
        el-col(:span="12")
          img.cube(:src='images.cube_img')
          CUONACUBE.graph(:height="320" :cubeEventCounts="api.eventCountsByDeviceType.cube" ref="cube")
          .legend(v-html="legends.cube")

        el-col(:span="12")
          img.tag(:src='images.tag_img')
          CUONATAG.graph(:height="320" :tagEventCounts="api.eventCountsByDeviceType.tag"  ref="tag")
          .legend(v-html="legends.tag")

    DeviceList(:actionFilters="params.actions", :groups="params.groups", :daterange="params.daterange")

</template>

<script>
import actions from '@/utils/defines/actions.js';
import CUONACUBE from './Cube';
import CUONATAG from './Tag';
import DeviceList from './DeviceList';
import API from '@/api/analytics';
import GroupApi from '@/api/group';
import { mapState } from 'vuex';
export default {
  components: { CUONATAG, CUONACUBE, DeviceList },
  data() {
    return {
      beforeMount: false,
      groups: [],
      params: {
        actions: [],
        groups: [],
        daterange: []
      },
      options: {
        shortcuts: [{
          text: this.$t('Analysis.last_week'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('Analysis.last_month'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('Analysis.past_3month'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      images: {
        cube: require('@/assets/cuona_cube.svg'),
        tag: require('@/assets/cuona_seal.svg'),
        cube_img: require('@/assets/cuona_cube.png'),
        tag_img: require('@/assets/cuona_tag.svg'),
        device_empty: require('@/assets/device_empty.svg')
      },
      legends: {
        cube: null,
        tag: null
      },
      api: {
        eventCountsByDeviceType: { cube: { }, tag: { } }
      }
    }
  },
  title() {
    return this.$t('menus.device')
  },
  mixins: [actions],
  computed: {
    ...mapState({
      analysisFilters: state => state.analysis.analysisFilters
    }),
    chartData() {
      return {
        labels: this.labels,
        datasets: [{
          data: this.counts,
          backgroundColor: this.backgroundColors
        }]
      }
    }
  },
  beforeMount() {
    this.beforeMount = true;
    this.params = this.analysisFilters;
  },
  mounted() {
    this.$nextTick(function () {
      this.beforeMount = false;
      this.updateChartData();
      this.getGroups();
    });
  },
  methods: {
    getGroups: function() {
      GroupApi.getGroups()
        .then((groups) => {
          this.groups = groups;
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Group.failed_get'),
            type: 'error'
          });
        })
    },
    updateChartData: function () {
      if(this.beforeMount) return;
      this.$store.commit('setAnalysisFilters', this.params);
      const that = this;
      const reqParams = {
        daterange: this.params.daterange,
        action_types: this.params.actions,
        groups: this.params.groups
      };
      API.getEventCountByDeviceType(reqParams).then(function (response) {
        if (response && response.event_counts_by_device_type) {
          that.api.eventCountsByDeviceType = response.event_counts_by_device_type;
          if (that.api.eventCountsByDeviceType.cube === undefined) {
            that.api.eventCountsByDeviceType.cube = { };
          }
          if (that.api.eventCountsByDeviceType.tag === undefined) {
            that.api.eventCountsByDeviceType.tag = { };
          }
        } else {
          that.api.eventCountsByDeviceType = { cube: { }, tag: { } };
        }
      }).then(function(){
        that.legends.cube = that.getCuonaLegend('cube')
        that.legends.tag  = that.getCuonaLegend('tag')
      });
    },
    checkEmptyData: function(type)
    {
      let types = this.api.eventCountsByDeviceType
      return 0 < Object.keys((type === 'cube' ? types.cube : types.tag)).length ? false : true
    },
    getCuonaLegend: function(type)
    {
      let labels = this.$refs[type].chartData.labels
      let colors = this.$refs[type].chartData.datasets[0].backgroundColor

      var html = '<ul>'
      let list = labels.map(function(label, index){
        return '<li><span class="mark" style="background-color:'+colors[index]+'"></span>'+label+'</li>'
      })
      html += list.join('')
      html += '</ul>'
      return html
    }
  },
  watch: {
    "params.daterange"() {
      this.updateChartData();
    },
    "params.actions"() {
      this.updateChartData();
    },
    "params.groups"() {
      this.updateChartData();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";

.analysisDevice {
  padding-top: 80px;

  header {
    position: fixed;
    z-index: 100;
    width: calc(100vw - 320px);
    margin-top: -80px;
    background: #FEFEFE;
    padding: 15px 40px;
    border-bottom: 1px solid $border;

    .action, .group {
      width: 240px;
      margin: 0 20px 0 0;
    }
    .picker {
      width: 280px;
      float: right;
    }
  }

  #graphs {
    background: #FFF;
    margin: 20px 40px;
    border: 1px solid $border;
    border-radius: 5px;
    padding-bottom: 40px;

    .el-row {
      display: flex;
      align-content: flex-start;

      .el-col {
        padding: 0 20px 20px 20px;
        text-align: center;
        margin-right: 20px;

        .graph {
          position: relative;
          z-index: 90;
        }

        .legend ::v-deep {
          display: block;
          width: 200px;
          margin: 0 auto;
          text-align: left;
          font-size: 12px;
          ul {
            list-style: none;
            li {
              line-height: 1.5;
              span.mark {
                display: inline-block;
                width: 40px;
                height: 13px;
                margin-right: 5px;
                border-radius: 3px;
                vertical-align: middle;
              }
            }
          }
        }

        img.cube, img.tag {
          position: relative;
          z-index: 89;
          top: 205px;
          left: 0px;
          height: 84px;
          margin-top: -120px;
        }
        img.tag {
          top: 210px;
          height: 90px;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .devices-list {
      border-top: 1px solid $border;
    }

    .devices-graph,
    .devices-list {
      padding: 30px 40px;
      position: relative;

      h1 {
        display: block;
        padding: 0;
        margin: 0 0 20px 0;
        font-size: 16px;
        font-weight: normal;
      }
      .mode {
        position: absolute;
        right: 70px;
        top: 34px;
      }
    }
  }
}

span.count {
  display: inline-block;
  text-align: center;
  background: $border;
  min-width: 20px;
  padding: 1px 6px;
  font-size: 12px;
  border-radius: 15px;
  margin-left: 8px;
}

</style>
